import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {WebFormSummary} from '../../models/WebFormSummary';

@Component({
    selector: 'app-form-page-summary',
    templateUrl: './form-page-summary.component.html',
    styleUrls: ['./form-page-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormPageSummaryComponent implements OnInit {

  @Input() pageSummary: WebFormSummary;
  @Output() modifyButtonClicked = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  trackByFn(index: number): number {
    return index;
  }

  handleModifyClick(): void {
    this.modifyButtonClicked.emit(this.pageSummary.pageIndex);
  }
}
